import React from 'react';
import { FaCode, FaMobileAlt, FaChartLine, FaAd } from 'react-icons/fa';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: <FaCode size={40} />,
      title: "Développement Web",
      description: "Sites vitrines et e-commerce performants avec les dernières technologies",
      features: ["React/Next.js", "Node.js", "SEO Optimisé", "Responsive Design"]
    },
    {
      icon: <FaMobileAlt size={40} />,
      title: "Applications Mobile",
      description: "Solutions iOS et Android natives ou cross-platform",
      features: ["React Native", "Flutter", "Performance", "UI/UX"]
    },
    {
      icon: <FaChartLine size={40} />,
      title: "Marketing Digital",
      description: "Stratégies pour booster votre visibilité en ligne",
      features: ["SEO", "Content Marketing", "Stratégie Social Media", "Analyse"]
    },
    {
      icon: <FaAd size={40} />,
      title: "Publicité Digitale",
      description: "Campagnes ciblées sur les réseaux sociaux et Google",
      features: ["Facebook Ads", "Google Ads", "Retargeting", "Analytics"]
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <h2 className="section-title">Nos Services</h2>
        <p className="section-subtitle">Des solutions complètes pour votre présence digitale</p>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p className="service-description">{service.description}</p>

              <ul className="service-features">
                {service.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>

              <a href="#contact" className="btn-outline">Demander un devis</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;